import React from 'react';
import { FlexControlledForm } from '@common-fe/common-fe';

import useCoverageLevelsItem from './hooks/useCoverageLevelsItem';
import { StyledBox } from './CoverageLevelsItem.styles';
import CoverageLevelsItemHeader from './CoverageLevelsItemHeader';

interface Props {
  coverageId: string;
  title: string;
  isEditMode?: boolean;
  isTemplateMode?: boolean;
  isActiveMode?: boolean;
  isDeletable?: boolean;
  isHighlighted?: boolean;
}

const CoverageLevelsItem: React.FC<Props> = ({
  title,
  isEditMode,
  isTemplateMode,
  isActiveMode,
  isDeletable,
  isHighlighted,
  coverageId,
}) => {
  const { handleDelete, fields, showErrors, formKey, setValues } = useCoverageLevelsItem({
    coverageId,
    isEditMode,
    isTemplateMode,
    isActiveMode,
  });

  return (
    <StyledBox
      direction="column"
      round="container1Round"
      background="canvas"
      elevation="default"
      isHighlight={isHighlighted}
      border={{ color: 'border2', size: 'small' }}
    >
      <FlexControlledForm
        key={formKey}
        testId={`coverage-level-${coverageId}`}
        fields={fields}
        subTitle={
          <CoverageLevelsItemHeader
            title={title}
            isEditMode={isEditMode}
            isDeletable={isDeletable}
            onDelete={handleDelete}
          />
        }
        showError={showErrors}
        editMode={isEditMode}
        onChangeValues={setValues}
        isThinMode
      />
    </StyledBox>
  );
};

export default React.memo(CoverageLevelsItem);
